import { render, staticRenderFns } from "./CardDialog.vue?vue&type=template&id=3715cff4&scoped=true&style=background%3A%20var(--v-muted-base)%3B&"
import script from "./card-dialog.component.ts?vue&type=script&lang=ts&"
export * from "./card-dialog.component.ts?vue&type=script&lang=ts&"
import style0 from "./CardDialog.vue?vue&type=style&index=0&id=3715cff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3715cff4",
  null
  
)

export default component.exports